import { routerService } from '@/services';

const model = {
  namespace: 'routerModel',
  state: {
    location: {},
    matchParams: {},
  },
  subscriptions: {},
  effects: {
    *push({ payload }, { call }) {
      yield call(routerService.push, payload);
    },
    *replace({ payload }, { call }) {
      yield call(routerService.replace, payload);
    },
  },
};

export default model;
